import { OnEventDispatcher } from './on-event-dispatcher';
export class FrameLoop extends OnEventDispatcher {
    time: number;
    constructor() {
        super();

        this.time = Date.now();

        let loop:()=>void;
        loop = () => {
            this.onLoop();
            requestAnimationFrame(loop);
        }
        loop();
    }
    private onLoop() {
        let tnow:number = Date.now();
        let delta:number = (tnow-this.time) / 1000.0;
        this.time = tnow;
        this.dispatch("loop", delta);
    }
}